import { EMBED_REGISTRY } from '@/embed/registry';
import { EmbedMessage } from '@/embed/EmbedMessage';

/**
 * The embed shell. Rendered (without the admin Clerk gate or AdminShell) when
 * bcecloud is loaded inside a Salesforce Canvas iframe. It reads the widget
 * selector and record context from the URL the `/canvas` SSO handler redirected
 * to, and dispatches through {@link EMBED_REGISTRY} to the matching widget.
 *
 * Authentication is the session cookie that SSO set — there is no sign-in UI
 * here; an unauthenticated embed simply fails its data calls and the widget
 * shows its error state.
 *
 * @returns The embedded widget, or an empty state for an unknown selector.
 */
export function EmbedApp(): React.ReactElement {
  const params = new URLSearchParams(window.location.search);
  const componentName = params.get('componentName') ?? '';
  const externalId = params.get('externalId') ?? '';
  const sObjectType = params.get('sObjectType') ?? '';

  const entry = EMBED_REGISTRY[componentName];

  // No min-height: the widget is only as tall as its content, so the Salesforce
  // panel does not blow out to a full screen (least of all when erroring).
  return (
    <div className="bg-portal-bg p-3">
      {entry ? (
        <entry.Component externalId={externalId} sObjectType={sObjectType} />
      ) : (
        <EmbedMessage
          text={
            componentName
              ? `No bcecloud widget is registered for "${componentName}".`
              : 'This embed was opened without a widget to show.'
          }
        />
      )}
    </div>
  );
}
